let isMobile = null;
try {
    isMobile = require("ismobilejs");
}
catch (e) {
}
export var ProjectDomUtils;
(function (ProjectDomUtils) {
    function runScripts(html, callback = null) {
        const s = html.getElementsByTagName('script');
        let loaded = 0;
        function scriptLoaded(e) {
            loaded++;
            if (s.length === loaded) {
                if (callback) {
                    callback();
                }
            }
        }
        for (let i = 0; i < s.length; i++) {
            const node = s[i], parent = node.parentElement, d = document.createElement('script');
            d.async = node.async;
            d.src = node.src;
            if (callback) {
                d.onload = scriptLoaded;
            }
            if (parent) {
                parent.insertBefore(d, node);
                parent.removeChild(node);
            }
        }
    }
    ProjectDomUtils.runScripts = runScripts;
    function getScrollElement(doc = document) {
        return doc.scrollingElement || doc.documentElement;
    }
    ProjectDomUtils.getScrollElement = getScrollElement;
    function getHighestZIndex(domNode) {
        let highestZIndex = 0;
        let currentZIndex = 0;
        const nodes = domNode.getElementsByTagName('*');
        for (let i = 0; i < nodes.length; i++) {
            currentZIndex = Number(window.getComputedStyle(nodes[i]).zIndex);
            if (currentZIndex > highestZIndex) {
                highestZIndex = currentZIndex;
            }
        }
        return highestZIndex;
    }
    ProjectDomUtils.getHighestZIndex = getHighestZIndex;
    function stylesheetLoaded(link, callback, context = null) {
        if (!context) {
            context = document;
        }
        let timeout1;
        let timeout2;
        function trying() {
            timeout1 = setTimeout(() => {
                for (let i = 0; i < context.styleSheets.length; i++) {
                    let sheet = context.styleSheets[i];
                    if (sheet.href == link) {
                        clearTimeout(timeout1);
                        clearTimeout(timeout2);
                        return callback();
                    }
                }
                trying();
            }, 10);
        }
        timeout2 = setTimeout(() => {
            logger.error('stylesheet loader timeout');
            clearTimeout(timeout1);
            clearTimeout(timeout2);
            callback();
        }, 2000);
        trying();
    }
    ProjectDomUtils.stylesheetLoaded = stylesheetLoaded;
    function loadScript(data, context = null) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        for (let key in data) {
            script.setAttribute(key, data[key]);
        }
        if (!context) {
            context = document;
        }
        context.getElementsByTagName('head')[0].appendChild(script);
    }
    ProjectDomUtils.loadScript = loadScript;
    function onUnload() {
        return new Promise((resolve, reject) => {
            function done() {
                resolve();
            }
            window.addEventListener('beforeunload', done);
            window.addEventListener('pagehide', done);
            window.addEventListener('onunload', done);
        });
    }
    ProjectDomUtils.onUnload = onUnload;
    function waitForData(name, context) {
        if (!context) {
            context = window;
        }
        return new Promise((resolve, reject) => {
            let interval;
            if (context[name]) {
                resolve();
            }
            else {
                interval = setInterval(() => {
                    if (context[name]) {
                        clearInterval(interval);
                        resolve();
                    }
                }, 200);
            }
        }).catch((e) => {
            logger.error(e);
        });
    }
    ProjectDomUtils.waitForData = waitForData;
    function localToScreen(el) {
        return this.localToGlobal(el, true);
    }
    ProjectDomUtils.localToScreen = localToScreen;
    function localToGlobal(el, screenOffset = false) {
        const screen = el.getBoundingClientRect();
        if (screenOffset) {
            return screen;
        }
        const top = screen.top + this.scrollY();
        const left = screen.left + this.scrollX();
        return { top: top, left: left, bottom: top + el.offsetHeight, right: left + el.offsetWidth };
    }
    ProjectDomUtils.localToGlobal = localToGlobal;
    function screenToLocal(parentOfEl, globalPos) {
        return this.globalToLocal(parentOfEl, globalPos, true);
    }
    ProjectDomUtils.screenToLocal = screenToLocal;
    function globalToLocal(parentOfEl, globalPos, screenOffset = false) {
        logger.error('given element is empty');
        return { top: 0, left: 0, bottom: 0, right: 0 };
    }
    ProjectDomUtils.globalToLocal = globalToLocal;
    function scrollY() {
        return window.scrollY || window.pageYOffset;
    }
    ProjectDomUtils.scrollY = scrollY;
    function scrollX() {
        return window.scrollX || window.pageXOffset;
    }
    ProjectDomUtils.scrollX = scrollX;
    function onRendered(element, onComplete) {
        let interval = null;
        function check() {
            if (element.offsetWidth > 0 && element.offsetHeight) {
                clearInterval(interval);
                onComplete();
                return true;
            }
            else {
                return false;
            }
        }
        if (!check()) {
            interval = setInterval(check, 100);
        }
    }
    ProjectDomUtils.onRendered = onRendered;
    function onClickOutsideOf(html, callback) {
        document.addEventListener('click', (e) => {
            let checkHtml = e.target;
            let foundHtml = false;
            while (checkHtml) {
                if (checkHtml === html) {
                    foundHtml = true;
                }
                checkHtml = checkHtml.parentElement;
            }
            if (!foundHtml) {
                callback(e);
            }
        });
    }
    ProjectDomUtils.onClickOutsideOf = onClickOutsideOf;
})(ProjectDomUtils || (ProjectDomUtils = {}));
